<template>
  <div class="order-operation" v-if="order">
      <h3>订单信息</h3>
      <calculate-order-price ref="calculateOrderPriceRef" :order-no="order.order_no"></calculate-order-price>
      <charge-order ref="chargeOrderRef" :order-no="order.order_no"></charge-order>

      <div class="d-inline-block">
        <button class='btn btn-sm btn-primary mr-2' @click="updateOrder" v-if="isAdmin || isPrinter || (isCompany && !isCompanyReadonly)">更新</button>
        <button class='btn btn-sm btn-primary mr-2' @click="previewShipTicket">预览快递单</button>
        <button class='btn btn-sm btn-primary mr-2' @click="getOrderXML">下载xml</button>
        <button class="btn btn-sm btn-primary mr-2" @click="showCalculateOrderPriceModel" v-if="isAdmin || isPrinter || (isCompany && !isCompanyReadonly)">计算价格</button>
        <create-after-sale :order='order'></create-after-sale>
        <button type='button' class='btn btn-sm btn-danger mx-2' @click="deleteOrder" v-if="allowOrderBeDeleted()">删除</button>
        <button type='button' class='btn btn-sm btn-primary mr-2' @click="showChargeOrderModel" v-if="isAdmin || isPrinter">收取费用</button>
        <button type='button' class='btn btn-sm btn-primary mr-2' @click="updateDelivery">更新物流</button>
      </div>
    </h3>
    <hr>
    <form>
      <div class="form-group row">
        <label for="company-name" class="col-2 col-form-label">公司</label>
        <div class="col-4">
          <input class="form-control" type="text" :value="getCompanyDisplay(order.company_code)" id="company-name-input" readonly>
        </div>
        <label for="created-at" class="col-2 col-form-label">接收时间</label>
        <div class="col-4">
          <input class="form-control" type="text" :value="formatTime(order.created_at)" id="created-at" readonly>
        </div>
      </div>
      <div class="form-group row">
        <label for="order-no" class="col-2 col-form-label">内部订单号</label>
        <div class="col-4">
          <input class="form-control" type="text" :value="order.order_no" id="order-no" readonly>
        </div>

        <label for="company-order-no" class="col-2 col-form-label">外部订单号</label>
        <div class="col-4">
          <input class="form-control" type="text" :value="order.company_order_no" id="company-order-no" readonly>
        </div>
      </div>
      <div class="form-group row">
        <label for="product-code" class="col-2 col-form-label">产品码</label>
        <div class="col-4">
          <input class="form-control" type="text" :value="order.product_code" id="product-code" readonly>
        </div>
        <label for="order-status" class="col-2 col-form-label">状态</label>
        <div class="col">
          <select class="form-control" id="order-status" v-model="order.status">
            <option v-for="(display, status) in orderStatusList" :value="status">{{display}}</option>
          </select>
        </div>
      </div>
      <div class="form-group row">
        <label for="product-code" class="col-2 col-form-label">产品名</label>
        <div class="col-4">
          <input class="form-control" type="text" v-model="order.order_name" id="order-name">
        </div>
        <label for="order-count" class="col-2 col-form-label">订单份数</label>
        <div class="col">
          <input class="form-control" type="text" :value="`${calculateOrderItemsCount(order)} 册 X ${order.count} 份`" id="order-count" readonly>
        </div>
      </div>

      <div class="form-group row">
        <label for="consigne-name" class="col-2 col-form-label">收件人</label>
        <div class="col-4">
          <input class="form-control" type="text" v-model="order.consignee_name" id="consignee-name">
        </div>
        <label for="consignee-phone" class="col-2 col-form-label">手机</label>
        <div class="col-4">
          <input class="form-control" type="text" v-model="order.consignee_phone" id="consignee-phone">
        </div>
      </div>
      <address-picker :value="order.consignee_address" v-on:input="updateAddress"></address-picker> 
      <div class="form-group row">
        <label for="ship-company" class="col-2 col-form-label">快递公司</label>
        <div class="col">
          <select class="form-control" id="ship-company" v-model="order.ship_company">
            <option v-for="(display, ship_company) in shipCompanyList" :value="ship_company">{{display}}</option>
          </select>
        </div>
        
        <label for="ship-no" class="col-2 col-form-label">快递单号</label>
        <div class="col-4">
          <input class="form-control" type="text" v-model="order.ship_no" id="ship-no">
        </div>
      </div>
      <div class="form-group row">
        <div class="col-6">
          <label for="user-notes">用户留言(会被打印到快递单上)</label>
          <textarea class="form-control text-danger" id="user-notes" rows="3" v-model="order.user_notes"></textarea>
        </div>

        <div class="col-6">
          <label for="admin-notes">管理员留言</label>
          <textarea class="form-control text-danger" id="admin-notes" rows="3" v-model="order.admin_notes"></textarea>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-6">
          <label for="extra-items">附件</label>
          <textarea class="form-control text-danger" id="extra-items" :rows="order.extra_items.length + 2" readonly>{{generateOrderExtraItems(order.extra_items)}}</textarea>
        </div>
      </div>
    </form>
  </div>
</template>

<script type="text/javascript">
import OrderMixin from '@/mixins/order'
import RoleMixin from '@/mixins/role'
import LocalTime from '@/components/_small/LocalTime'
import {formatTime} from '@/utils/time'
import AddressPicker from '@/components/_partial/AddressPicker'
import CreateAfterSale from '@/components/_small/CreateAfterSale'
import CalculateOrderPrice from '@/components/_order/CalculateOrderPrice'
import ChargeOrder from '@/components/_order/ChargeOrder'

function generateOrderExtraItems (items) {
  let lines = []
  for (let i in items) {
    lines.push(items[i].name + ' X ' + items[i].count)
  }
  return lines.join('\n')
}

function updateOrder () {
  let data = {
    order_name: this.order.order_name,
    consignee_name: this.order.consignee_name,
    consignee_phone: this.order.consignee_phone,
    ship_no: this.order.ship_no,
    user_notes: this.order.user_notes,
    admin_notes: this.order.admin_notes,
    status: this.order.status,
    ship_company: this.order.ship_company
  }
  // 获取地址
  if (this.address) {
    data.consignee_address = this.address
  }

  this.$http.put('/api/orders/' + this.order.order_no, data).then(response => {
    this.$emit('refresh')
    setTimeout(response => {
      location.href = '/orders?company_order_no=' + this.order.company_order_no
    }, 300)
  })
}

function allowOrderBeDeleted () {
  if (this.isAdmin || this.isPrinter) {
    return true
  }
  if (this.isCompanyReadonly) {
    return false
  }

  if (this.order && ['created', 'create_failed', 'downloaded', 'download_failed', 'post_sale'].indexOf(this.order.status) > 0) {
    return true
  }
  return false
}

function previewShipTicket () {
  let url = '/tickets?order_nos=' + this.order.order_no + '&preview=true'
  window.open(url, '_blank')
}

function updateAddress (event) {
  this.address = event
}

function deleteOrder () {
  let ok = confirm('确定删除订单吗？')
  if (!ok) {
    return
  }

  let message = prompt('请输入删除理由')
  if (!message.trim()) {
    return
  }

  this.$http.post(`/api/orders/${this.order.order_no}/delete`, {
    reason: message
  }).then(response => {
    setTimeout(redirect, 2000)
  })
}

function getOrderXML () {
  let url = '/api/orders/' + this.order.order_no + '/xml'
  window.open(url, '_blank')
}

function redirect () {
  location.href = '/orders'
}

function showCalculateOrderPriceModel () {
  this.$refs.calculateOrderPriceRef.showCalculateOrderPriceModel()
}

function showChargeOrderModel () {
  this.$refs.chargeOrderRef.showChargeOrderModel()
}

function updateDelivery () {
  this.$http.post(`/api/orders/${this.order.order_no}/delivery`)
}

export default {
  name: 'order-operation',
  mixins: [OrderMixin, RoleMixin],
  props: ['order'],
  components: {
    AddressPicker,
    LocalTime,
    CreateAfterSale,
    CalculateOrderPrice,
    ChargeOrder
  },
  data () {
    return {
      address: ''
    }
  },
  methods: {
    updateOrder,
    updateAddress,
    generateOrderExtraItems,
    deleteOrder,
    showChargeOrderModel,
    previewShipTicket,
    getOrderXML,
    allowOrderBeDeleted,
    formatTime,
    showCalculateOrderPriceModel,
    updateDelivery
  }
}
</script>